import { useRouter } from 'next/compat/router';
import {
  DEFAULT_SORT_VALUE,
  SALES_AGENT,
} from '../components/search-filter-bar/enums';
import { getSearchFromQuery } from '../utils';
import { SearchResultsState } from '../utils/get-search-from-query';

export interface InitialSearch {
  isAgency: boolean;
  suburbs: string;
  page?: string;
  keywordName?: string;
  agentFilter?: string;
  sortBy?: string;
}

/**
 * Resolves the search the page should render, preferring the client-side route
 * over the props the server rendered with.
 */
const useSearchState = ({
  isAgency,
  suburbs,
  page,
  keywordName,
  agentFilter,
  sortBy,
}: InitialSearch): SearchResultsState | null => {
  const router = useRouter();

  const state = getSearchFromQuery(
    {
      isAgency,
      suburbs,
      keywordName,
      page: page ?? '1',
      agentFilter: agentFilter ?? SALES_AGENT,
      sortBy: sortBy ?? DEFAULT_SORT_VALUE,
    },
    router?.query,
    router?.pathname,
  );

  if (!state) {
    return null;
  }

  return {
    ...state,
    forceNewSearchPage: router?.query?.forcesearchpage2026 === '1',
  };
};

export default useSearchState;
